import moment from "moment";

export default {
  getUUID() {
    //生成UUID
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
        16
      );
    });
  },
  getSuffix(fileName) {
    //获取文件后缀名
    var first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
    var namelength = fileName.length; //取到文件名长度
    var filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
    return `${filesuffix}`;
  },
  // 验证身份证号
  isIDcard: (rule, value, callback) => {
    if (!/^[1-9][0-9]{16}[0-9|x|X]$/.test(value)) {
      callback(new Error("请输入正确的身份证号"));
    } else {
      callback();
    }
  },
  // 验证手机号
  isPhone: (rule, value, callback) => {
    if (!/^1[0-9]{10}$/.test(value)) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
  },
  //时间戳转年月日时分
  formattingDate(val) {
    if (!val) {
      return "";
    }
    var date = new Date(val);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var s =
      ":" +
      (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
    let data = {
      day: Y + M + D,
      hour: Y + M + D + h,
      minute: Y + M + D + h + m,
      second: Y + M + D + h + m + s
    };
    return data;
  },
  // 年月日转时间戳
  timestamp(date) {
    if (date == "") {
      return "";
    }
    let a = date.replace(/-/g, "/");
    return new Date(a).getTime();
  },
  // 时间戳转天时分秒
  formatDuring(mss) {
    var days = parseInt(mss / (1000 * 60 * 60 * 24));
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = parseInt((mss % (1000 * 60)) / 1000);
    return (
      days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 "
    );
  },
  // 表格时间戳转日期
  dateFormat(row, column) {
    let date = row[column.property];
    if (date == undefined || date == "") {
      return "";
    }
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  },
  mathAdd(arg1, arg2) {
    //加法
    var r1, r2, m;
    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (this.mathMul(arg1, m) + this.mathMul(arg2, m)) / m;
  },
  mathMul(arg1, arg2) {
    //乘法
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {
        // 
    }
    try {
      m += s2.split(".")[1].length;
    } catch (e) {
        // 
    }
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  },
  // 密码验证
	validatePwd(str) {
		let r = [true, ''];
		if (!/(?!^[0-9]+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{8,}$/.test(str)) {
			r = [false, '密码由数字、小写字母、大写字母和特殊字符中的任意两种或以上组成，且长度不小于8位']
		}
		return r
	},
  // 空字符串返回-
  fomateString(str){
    if(str){
      return str.length?str:'-'
    }else{
      return  '-'
    }
  },
};
